<div class="modal-overlay" mat-dialog-content>
  <div  class="AddEndpoints modal-content">
    <div class="bottom-left-img">
      <img src="assets/images/grpLogo.svg" alt="" class="logo-img">
    </div>
    <div class="modalHead">
      <h3>{{(isAdd ? 'Add New' : 'Edit') | translate}} {{data.label | translate}} {{!isAdd ? ('Details' | translate) : ''}}</h3>
    </div>
    <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
    <div class="modalBody">
      <div class="mb-4">
        <div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{(data.label === 'Employee' ? 'EmployeeID' : data.label) | translate}} {{ (data.label !== 'Employee' ? 'Name' : ' ') | translate }}</mat-label>
                <input matInput [(ngModel)]="customEntity.name" required />
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-tag"></i>
                </mat-icon>
                <mat-error>{{(data.label === 'Employee' ? 'EmployeeID' : data.label) | translate}} {{ (data.label !== 'Employee' ? 'Name' : ' ') | translate}} {{'is required' | translate}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{'Organization Level' | translate}}</mat-label>
                <mat-select [(ngModel)]="customEntity.organizationLevelId" required [panelClass]="'hierarchical-select-panel'">
                  <mat-option>
                    <ngx-mat-select-search [(ngModel)]="orgLevelSearch" [placeholderLabel]="('Search' | translate) + '...'"
                      (ngModelChange)="rebuildFilteredOrgs()">
                    </ngx-mat-select-search>
                  </mat-option>
                  @if (filteredOrgs.length === 0) {
                    <mat-option disabled>
                      {{ 'No options found' | translate }}
                    </mat-option>
                  }
                  <ng-container *ngTemplateOutlet="renderTree; context: { nodes: filteredOrgs, level: 0}"></ng-container>
                  <ng-template #renderTree let-nodes="nodes" let-level="level">
                    @for (node of nodes; track trackById($index, node)) {
                      <mat-option [value]="node.id" [ngClass]="'mat-level-' + level">
                        @for (i of [].constructor(level); track trackByIndex(idx); let idx = $index) {
                          <div class="pre-option-line" [ngClass]="'pre-option-level-' + idx"></div>
                        }
                        {{ node.name }}
                      </mat-option>
                      @if (node.children && node.children.length > 0) {
                        <ng-container
                        *ngTemplateOutlet="renderTree; context: { nodes: node.children, level: level + 1 }"></ng-container>
                      }
                    }
                  </ng-template>
                </mat-select>
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-building"></i>
                </mat-icon>
                <mat-error>{{'Organization Level' | translate}} {{'is required' | translate}}</mat-error>
              </mat-form-field>
            </div>

            @if (isLocationField) {
              <div class="col-md-12">
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-globe-asia"></i>
                </mat-icon>
                <mat-label>
                  {{'Use Static GPS Coordinates' | translate}}
                </mat-label>
                <mat-slide-toggle class="ml-3" [(ngModel)]="customEntity.useStaticGpsCoordinates">
                </mat-slide-toggle>
              </div>
            }

            @if (isLocationField && customEntity.useStaticGpsCoordinates) {
              <div class="col-md-12 geo-location-section mt-3">
                <div class="label d-flex justify-content-between align-items-center mb-1">
                  <span>{{'Geolocation' | translate}}</span>
                  <button type="button" class="btn geo-location-selector" [disabled]="isGeoDialogOpen" (click)="selectGeoLocation()">
                    <i class="fas fa-map-marker-alt mr-1"></i>{{'Select on map' | translate}}
                  </button>
                </div>
                <div class="location mb-1">
                  <label for="lat">{{'Lat' | translate}}</label>
                  <input id="lat" type="number" [(ngModel)]="customEntity.latitude" />
                </div>
                <div class="location">
                  <label for="lng">{{'Lon' | translate}}</label>
                  <input id="lng" type="number" [(ngModel)]="customEntity.longitude" />
                </div>
              </div>
            }

            <div class="custom-fields">
              @for (field of customFields; track trackById($index, field)) {
                <div class="col-md-12">
                  @if (field.name !== 'EmployeeID') {
                    <!-- Editable text field -->
                    @if ((canEditFields || isAdd) && !field.isDropdown) {
                      <mat-form-field>
                        <mat-label>{{field.name | translate}}</mat-label>
                        <input matInput [(ngModel)]="customEntity[field.property]" [readonly]="!isAdd && !canEditFields" [required]="columnConfig[field.property]?.isRequired" />
                        <mat-icon matPrefix class="mr-3">
                          <i class="fas fa-file-alt"></i>
                        </mat-icon>
                        @if (canEditFields) {
                          <mat-icon matSuffix class="ml-3 action-icon" [title]="'Edit' | translate" (click)="addEditField(field, $event)">
                            <i class="fas fa-edit"></i>
                          </mat-icon>
                        }
                        <mat-error>{{field.name | translate}} {{'is required' | translate}}</mat-error>
                      </mat-form-field>
                    }
                    <!-- Read-only text display -->
                    @if (!isAdd && !canEditFields && !field.isDropdown) {
                      <div class="readonly-field">
                        <label class="readonly-label">{{field.name | translate}}@if (field.isPii) {
                          <span class="status-badge status-badge--inactive">{{ 'PII' | translate }}</span>
                        }</label>
                        <div class="readonly-value">{{customEntity[field.property] || '-'}}</div>
                      </div>
                    }
                    <!-- Editable select field -->
                    @if ((canEditFields || isAdd) && field.isDropdown) {
                      <mat-form-field>
                        <mat-label>{{field.name | translate}}</mat-label>
                        <mat-select [(ngModel)]="customEntity[field.property]" [attr.disabled]="!isAdd && !canEditFields ? '' : null" [required]="columnConfig[field.property]?.isRequired">
                          @for (value of field.values; track trackByIndex($index)) {
                            <mat-option [value]="value">
                              {{value}}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-icon matPrefix class="mr-3">
                          <i class="fas fa-file-alt"></i>
                        </mat-icon>
                        @if (canEditFields) {
                          <mat-icon matSuffix class="ml-3 action-icon" [title]="'Edit' | translate" (click)="addEditField(field, $event)">
                            <i class="fas fa-edit"></i>
                          </mat-icon>
                        }
                        <mat-error>{{field.name | translate}} {{'is required' | translate}}</mat-error>
                      </mat-form-field>
                    }
                    <!-- Read-only select display -->
                    @if (!isAdd && !canEditFields && field.isDropdown) {
                      <div class="readonly-field">
                        <label class="readonly-label">{{field.name | translate}}@if (field.isPii) {
                          <span class="status-badge status-badge--inactive">{{ 'PII' | translate }}</span>
                        }</label>
                        <div class="readonly-value">{{customEntity[field.property] || '-'}}</div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>

          @if (canEditFields) {
            <div class="row">
              <div class="col-md-12">
                <div class="padding-y-10 clickable" (click)="addEditField(null, $event)" [title]="'Add Field' | translate">
                  <mat-label class="mr-1">{{'Add Field' | translate}}</mat-label>
                  <mat-icon matSuffix class="action-icon">
                    <i class="fas fa-plus"></i>
                  </mat-icon>
                </div>
              </div>
            </div>
          }
        </div>


        <div class="createButton mt-4">
          <button class="btn finalSubmit modal-footer-btn save-modal-btn" (click)="save()" [class.button-spinner]="isLoading"
            [disabled]="isDisabled() || isLoading">{{ submitButtonLabel | translate }}
          </button>
        </div>

        <div class="createButton mt-4">
          <button class="btn finalSubmit modal-footer-btn cancel-modal-btn" mat-dialog-close>{{'Cancel' | translate}}</button>
        </div>

      </div>

    </div>
  </div>
</div>
